import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './simplePagination.scss';

export default class SimplePagination extends React.PureComponent {
  constructor(props) {
    super(props);
    this.PAGES_PER_SIDE_OF_CURRENT_INDEX = 2;
    this.RANGE_OF_PAGES = this.PAGES_PER_SIDE_OF_CURRENT_INDEX * 2 + 1;
  }

  handlePaginationBtnClick = (index) => {
    if (index > 0 && index <= this.props.pageCount) {
      this.props.onPaginationBtnClick(index);
    }
  };

  getFirstIndexInRange = (current, pagesPerSide, safeRange, numberOfPages) => {
    const isFirstRange = current - pagesPerSide < 1;
    const isLastRange = current + pagesPerSide > numberOfPages;

    if (isFirstRange) {
      return 1;
    } else if (isLastRange) {
      return numberOfPages - (safeRange - 1);
    } else {
      return current - pagesPerSide;
    }
  };

  render() {
    const { className, pageCount, currentPage } = this.props;
    const safePageCount = pageCount ? pageCount : 1;

    const safeRangeOfPages =
      safePageCount < this.RANGE_OF_PAGES ? safePageCount : this.RANGE_OF_PAGES;

    const firstIndexInRange = this.getFirstIndexInRange(
      currentPage,
      this.PAGES_PER_SIDE_OF_CURRENT_INDEX,
      safeRangeOfPages,
      safePageCount
    );

    const isLastPage = currentPage === safePageCount;
    const isFirstPage = currentPage === 1;

    return (
      <ul
        className={`${styles.simplePagination}${
          className ? ` ${className}` : ''
        }`}
      >
        <PaginationGroup
          handlePaginationBtnClick={this.handlePaginationBtnClick}
          isDisabled={isFirstPage}
          stepPage={currentPage - 1}
          startIndex={1}
        />
        {Array(safeRangeOfPages)
          .fill()
          .map((_, index) => {
            const signedIndex = index + firstIndexInRange;
            return (
              <PaginationButton
                key={`paginationBtn:${index}`}
                index={signedIndex}
                className={styles.paginationButton}
                onClick={this.handlePaginationBtnClick}
                isSelected={currentPage === signedIndex}
              >
                {signedIndex}
              </PaginationButton>
            );
          })}
        <PaginationGroup
          handlePaginationBtnClick={this.handlePaginationBtnClick}
          isDisabled={isLastPage}
          stepPage={currentPage + 1}
          startIndex={safePageCount}
          rightSide
        />
      </ul>
    );
  }
}

SimplePagination.propTypes = {
  className: PropTypes.string,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPaginationBtnClick: PropTypes.func,
};

function PaginationGroup({
  handlePaginationBtnClick,
  isDisabled,
  stepPage,
  startIndex,
  rightSide,
}) {
  return (
    <div
      className={`${styles.arrowHolder} ${rightSide ? styles.reversed : ''}`}
    >
      <PaginationButton
        className={`${styles.arrowButton} ${isDisabled ? styles.disabled : ''}`}
        onClick={handlePaginationBtnClick}
        index={startIndex}
      >
        {!rightSide ? '‹‹' : '››'}
      </PaginationButton>
      <PaginationButton
        className={`${styles.arrowButton} ${isDisabled ? styles.disabled : ''}`}
        onClick={handlePaginationBtnClick}
        index={stepPage}
      >
        {!rightSide ? '‹' : '›'}
      </PaginationButton>
    </div>
  );
}

PaginationGroup.propTypes = {
  handlePaginationBtnClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  stepPage: PropTypes.number,
  startIndex: PropTypes.number,
  rightSide: PropTypes.bool,
};

function PaginationButton({ className, onClick, index, isSelected, children }) {
  function getClassNames() {
    return classNames({
      [styles.paginationButton]: true,
      [styles.isSelected]: isSelected,
      [className]: !!className,
    });
  }

  function handleBtnClick() {
    onClick(index);
  }

  return (
    <li>
      <button className={getClassNames()} onClick={handleBtnClick}>
        {children}
      </button>
    </li>
  );
}

PaginationButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  index: PropTypes.number,
  children: PropTypes.node,
  isSelected: PropTypes.bool,
};
